import { Component, Input, Injector, AfterViewInit } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operator/map';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'apertaricostruisci_12',
  templateUrl: 'apertaricostruisci_12.html',
})

export class ApertaRicostruisci_12Component extends Domanda_super implements AfterViewInit {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  prima_parte = [];
  seconda_parte = [];
  iselect_opened = [];
  risp = [];
  risposte_selezionabili = [];
  rispbutton = [];
  risposte_conferma = [];
  showconferma: boolean = true;
  showfeed: boolean = false;
  feed = '';
  count_domande = 0;
  showtime: boolean = true;
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';


  }
  resize(event, id_domanda) {
    // console.log(event);
    var x = document.getElementById(id_domanda);
    var element = x.children[0];
    var scrollHeight = element.scrollHeight;
    element.setAttribute('style', 'height:' + scrollHeight + 'px');
    x.style.height = (scrollHeight + 28) + 'px';
  }

  openselect(i) {
    if (!this.showconferma)
      return;

    for (let g = 0; g < this.iselect_opened.length; g++) {
      if (this.iselect_opened[g] == true)
        return;
    }

    /*if (this.rispbutton[i].testo != '')
      this.risposte_selezionabili.unshift(this.rispbutton[i]);
*/
    this.iselect_opened[i] = true;
  }

  // open_all(){
  //   for (let g = 0; g < this.iselect_opened.length; g++) {
  //     this.iselect_opened[g] = true
  //       // return;
  //   }
  // }
  frase_completa = '';
  risp_estatte = [];
  blocchi = [];
  v = {};
  show_blocchi = false; 
  ngOnInit(): void {
    this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
      this.v = v;
    })
    this.risp_estatte = [];
    this.events.publish('start_tempo', this.domanda);
    var risp_aux = [];
    for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
      this.iselect_opened[i] = false;
      this.rispbutton[i] = { testo: '' };
      let r = this.domanda['RispostaMicroStepList'][i];

      // console.log(r.testo);
      r.testo.match(/\[.+?\]/g).map((str) => {
        // console.log(str);
        var ris_esatta = str.replace('[', '').replace(']', '');
        this.risp_estatte.push(ris_esatta);
        risp_aux.push(r);
        this.count_domande++;
        this.risposte_conferma.push('');
        return str;
      });
      // console.log(this.risp_estatte);

      this.blocchi = r.testo.split(']');
      // console.log(this.blocchi);
      this.blocchi = this.blocchi.map((el, i) => {
        let indexopen = el.indexOf('[');
        var strhtml = '';
        var max = 0;
        if (this.risp_estatte[i] != undefined) {
          var r_arr = this.risp_estatte[i].split('#');
          r_arr.forEach(elx => {
            if (elx.length > max)
              max = elx.length;
          })
        }
        if (indexopen != -1) {
          strhtml = el.substr(0, indexopen);
          if (i != this.blocchi.length - 1)
            strhtml += '<span class="inputaperta"><input type="text" class="box-risposta" size="' + max + '" id="apertaricostruisci_' + r.id + '_' + i + '"></span><span class="risp_esatta" id="apertaricostruisci_' + r.id + '_' + i + 'e">' + this.risp_estatte[i].split('#').join(' | ') + '</span>';
        }
        else {
          strhtml = el;
        }
        return strhtml;
      })
      // console.log(this.blocchi);




      // let indexopen = r.testo.indexOf('[');
      // let indexclose = r.testo.indexOf(']');
      // r['prima_parte'] = r.testo.substr(0, indexopen);//.replace(/<\/?[^>]+(>|$)/g, "");
      // r['seconda_parte'] = r.testo.substr(indexclose + 1, r.testo.length);//.replace(/<\/?[^>]+(>|$)/g, "");
      // let risp_esatta = r.testo.substr(indexopen + 1, indexclose - indexopen - 1);

      // r.testo = risp_esatta;


      // }
      // else {
      //   r['prima_parte'] = '';
      //   r['seconda_parte'] = '';
      //   //this.risposte_selezionabili.push(r);
      //   risp_aux.push(r);
      // }
    }
    if (this.settingsmq.risposteCausali == '1')
      this.risposte_selezionabili = this.shuffle(risp_aux);
    else
      this.risposte_selezionabili = risp_aux;

    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });

  }

  // sel(r, i) {
  //   if (!this.showconferma)
  //     return;

  //   //this.risposte_selezionabili.splice(this.risposte_selezionabili.indexOf(r), 1);

  //   for (let f = 0; f < this.rispbutton.length; f++) {
  //     if (this.rispbutton[f].id == r.id)
  //       this.rispbutton[f] = { 'testo': '' };
  //   }

  //   this.iselect_opened[i] = false;
  //   this.rispbutton[i] = r;
  //   let risposte_output = [];

  //   this.rispbutton.forEach(element => {
  //     if (element.id != undefined)
  //       risposte_output.push(element.id);
  //   });
  //   this.risposte_conferma = risposte_output;
  //   //this.update_output(risposte_output); 

  // }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    let r = this.domanda['RispostaMicroStepList'][0];
    this.risp_estatte.forEach((el, i) => {
      var htmlel = document.getElementById("apertaricostruisci_" + r.id + "_" + i);
      htmlel.addEventListener('blur', (event) => {

        // this.risp_estatte.forEach((elx, i) => {
        if (event.target['value'].trim() != '') {
          var arrid = event.target['id'].split('_');
          var pos = parseInt(arrid[2]);
          var htmlelxx = document.getElementById("apertaricostruisci_" + r.id + "_" + pos);

          // console.log(event.target['value']);
          // console.log(this.risp_estatte[pos]);
          // console.log(pos);
          let condition = event.target['value'].endsWith('.0') && parseInt(event.target['value']) == this.risp_estatte[pos];
          //if (event.target['value'].toLowerCase().trim() == this.risp_estatte[pos].toLowerCase().trim() || condition) {
          var r_esatte_arr = this.risp_estatte[pos].toLowerCase().trim().split('#');
          if (!this.settingsmq['istest']) {
            if (r_esatte_arr.indexOf(event.target['value'].toLowerCase().trim()) != -1 || condition) {

              htmlelxx.classList.remove('area_red');
              htmlelxx.classList.add('area_green');
            }
            else {
              htmlelxx.classList.remove('area_green');
              htmlelxx.classList.add('area_red');
            }
          }
        }
        // })
      }, true);
    })
  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('apertaricostruisci', this.domanda, this.risposte_conferma);
  }
  position_class(h, len) {
    if (h == 0) {
      return 'first';
    }
    else if (h == len - 1)
      return 'last';
    else
      return '';
  }
  conferma(tempo?) {
    var r = this.domanda['RispostaMicroStepList'][0];
    this.risp_estatte.forEach((el, i) => {
      var htmlel = document.getElementById("apertaricostruisci_" + r.id + "_" + i);
      // console.log(htmlel.value);
      this.risposte_conferma[i] = htmlel['value'].trim();
    })

    // this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
    // console.log(this.risposte_conferma);
    // console.log(this.count_domande);
    if (this.risposte_conferma.indexOf('') != -1 && tempo != 'tempo') {
      setTimeout(() => {
        var pos = this.risposte_conferma.indexOf('');
        var htmlelpos = document.getElementById("apertaricostruisci_" + r.id + "_" + pos);
        htmlelpos.focus();
      }, 1000);
      
      this.presentToast(this.v);
      return;
    }

    this.risp_estatte.forEach((el, i) => {
      var htmlel = document.getElementById("apertaricostruisci_" + r.id + "_" + i);

      htmlel['readOnly'] = true;
    })


    this.events.publish('stop_tempo_parziale', this.domanda);
    let errate = [];
    let esatte = [];
    let corrette = [];
    // for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
    this.risp_estatte.forEach((el, i) => {


      let r = this.domanda['RispostaMicroStepList'][0];

      // let esatta_aux = r.testo.toLowerCase().trim();

      let miarisposta = this.risposte_conferma[i].toLowerCase().trim();

      let condition = this.risposte_conferma[i].endsWith('.0') && parseInt(this.risposte_conferma[i]) == el;
      var r_esatte_arr = el.toLowerCase().trim().split('#');
      //if (el.toLowerCase().trim() == miarisposta || this.risposte_conferma[i] == el || condition) //if di tutti i casi uppercase e se senzaspazi su inizio e fini
      if (r_esatte_arr.indexOf(miarisposta) != -1 || r_esatte_arr.indexOf(this.risposte_conferma[i]) != -1 || condition)
        esatte.push("apertaricostruisci_" + r.id + "_" + i);
      else
        errate.push("apertaricostruisci_" + r.id + "_" + i);
    })
    // if (r.punti != '0')
    //   corrette.push(r.id);
    // if (this.risposte_conferma.indexOf(r.id) != -1 && r.punti == '0')
    //   errate.push(r.id);
    // }
    // for (let i = 0; i < corrette.length; i++) {
    //   let c = corrette[i];
    //   if (c == this.risposte_conferma[i])
    //     esatte.push(c);
    //   else
    //     errate.push(c);
    // }

    // for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
    //   let r = this.domanda['RispostaMicroStepList'][i];
    //   if (this.risposte_conferma.indexOf(r.id) != -1) {
    //     if (r.punti != '0')
    //       esatte.push(r.id);
    //     else
    //       errate.push(r.id);
    //   }
    // }
    // console.log('esatte', esatte);
    // console.log('errate', errate);
    if (!this.settingsmq['istest'])
      this.changestyle(esatte, errate);
    if (errate.length == 0)
      this.feed = this.domanda['feedbackPositivo'];
    else if (esatte.length > 0)
      this.feed = this.domanda['feedbackParziale'];
    else
      this.feed = this.domanda['feedbackNegativo'];

    this.showfeed = true;
    this.showconferma = false;
    if (this.settingsmq['istest'])
      this.prosegui();

    // });
  }



  changestyle(esatte, errate) {

    // var y = document.getElementsByClassName("risp_esatta");    
    // var u;
    // for (u = 0; u < y.length; u++) {
    //   var s = y[u];
    //   if (errate.indexOf(l['id']) != -1) {
    //     l.classList.add('area_red');
    //   }
    // }
    var x = document.getElementsByClassName("box-risposta");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];
      // console.log(esatte);
      // console.log(l['id'])
      if (esatte.indexOf(l['id']) != -1) {
        l.classList.add('area_green');
      }
      else if (errate.indexOf(l['id']) != -1) {
        var y = document.getElementById(l['id'] + 'e');
        y.classList.add('showrisp');
        l.classList.add('area_red');
      }
    }
  }
  clone(obj) {
    let copy = (JSON.parse(JSON.stringify(obj)));
    return copy;
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/apertaricostruisci_12.ts